<template>
    <validation-observer ref="form" v-slot="{ meta, setFieldValue, errors }">
        <modal
            @hidden="clearData"
            @shown="setData"
            :id="modalId"
            :ok-disabled="!meta.valid"
            :title="title"
            @ok.prevent="submit"
        >
            <validation-provider name="title" rules="required">
                <form-input
                    :error="errors.title"
                    v-model="values.title"
                    label="Name"
                    @input="(val) => setFieldValue('title', val)"
                />
            </validation-provider>
            <div class="d-flex justify-content-between input-wrapper">
                <validation-provider name="value" as="div" class="w-100" rules="required|validNumber">
                    <form-input
                        :error="errors.value"
                        v-model="values.value"
                        label="Value"
                        @input="(val) => setFieldValue('value', val)"
                    />
                </validation-provider>
                <validation-provider name="pre_auth" as="div" class="w-100">
                    <form-select
                        :options="preAuthOptions"
                        :error="errors.pre_auth"
                        v-model="values.pre_auth"
                        label="Pre Auth"
                        @input="(val) => setFieldValue('pre_auth', val)"
                    />
                </validation-provider>
            </div>

            <small> Edits will appear on all properties where this deposit currently appears. </small>
        </modal>
    </validation-observer>
</template>

<script>
    import formInput from '../../generic/form-input/form-input.vue';
    import formSelect from '../../generic/form-select/form-select.vue';
    import modal from '../../generic/modal/modal.vue';

    export default {
        name: 'AddEditDepositModal',
        components: {
            formInput,
            formSelect,
            modal,
        },
        props: {
            initialData: {
                type: Object,
                default: null,
            },
            modalId: {
                type: String,
            },
        },
        data() {
            return {
                values: {
                    title: 'New Deposit',
                    value: '',
                    pre_auth: false,
                    id: null,
                },
            };
        },
        computed: {
            title() {
                return this.initialData ? 'Edit Deposit' : 'Add Deposit';
            },
            preAuthOptions() {
                return [
                    { value: true, text: 'Yes' },
                    { value: false, text: 'No' },
                ];
            },
        },
        methods: {
            submit() {
                this.$emit('submit', this.values);
            },
            setData() {
                if (this.initialData) {
                    this.values = {
                        title: this.initialData.title,
                        value: this.initialData.value,
                        pre_auth: this.initialData.pre_auth,
                        id: this.initialData.id,
                    };
                }
                this.$refs.form.setValues({
                    ...this.values,
                });
            },
            clearData() {
                this.$emit('hide');
                this.values = {
                    title: 'New Deposit',
                    value: '',
                    pre_auth: false,
                    id: null,
                };
            },
        },
        watch: {
            initialData() {
                this.setData();
            },
        },
    };
</script>

<style scoped>
    .input-wrapper {
        gap: 1rem;
    }
</style>
